import {
  CompetenzaFattureOutpuDto,
  CompetenzeMeseAnnoFattureOutputDto,
  Configuration,
  FattureProgettoControllerApi,
  SearchCompetenzeFattureCicloAttivoRequest,
} from '@api/client';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'core/store';
import getConfiguration, { errorHandler } from 'core/store/config';

enum FattureActions {
  getCompetenzeMeseAnnoByFatturaCicloAttivo = '[Fatture] Get competenze mese anno by fattura ciclo attivo',
  getCompetenzeMeseAnnoCicloAttivo = '[Fatture] Get competenze mese anno ciclo attivo',
  deassociateCompetenzeFattureCicloAttivo = '[Fatture] Deassociate competenze fatture ciclo attivo',
}

export const getCompetenzeMeseAnnoByFatturaCicloAttivo = createAsyncThunk<
  CompetenzaFattureOutpuDto | undefined,
  SearchCompetenzeFattureCicloAttivoRequest,
  ThunkApiConfig
>(FattureActions.getCompetenzeMeseAnnoByFatturaCicloAttivo, async (payload, { dispatch, extra, getState }) => {
  try {
    return await new FattureProgettoControllerApi(
      getConfiguration(Configuration, extra, getState)
    ).searchCompetenzeFattureCicloAttivo(payload);
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});

export const getCompetenzeMeseAnnoCicloAttivo = createAsyncThunk<
  CompetenzeMeseAnnoFattureOutputDto[] | undefined,
  number,
  ThunkApiConfig
>(FattureActions.getCompetenzeMeseAnnoCicloAttivo, async (idOrdine, { dispatch, extra, getState }) => {
  try {
    return await new FattureProgettoControllerApi(
      getConfiguration(Configuration, extra, getState)
    ).searchCompetenzefattureMeseAnno({ idOrdine });
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});

export const deassociateCompetenzeFattureCicloAttivo = createAsyncThunk<
  void,
  { idOrdine: number; idProject: string; fkRowFattura: string },
  ThunkApiConfig
>(FattureActions.deassociateCompetenzeFattureCicloAttivo, async (payload, { dispatch, extra, getState }) => {
  try {
    await new FattureProgettoControllerApi(
      getConfiguration(Configuration, extra, getState)
    ).deleteFatturaCompetenzaMeseAnnoAttivo(payload);
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});
